export const MUSICNAME = "Yn-music";
